import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect, useDispatch } from 'react-redux';
import MuiAlert from '@material-ui/lab/Alert';
import {  } from "pages/redux/actions";
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton';
// import CloseIcon from '@material-ui/icons/Close';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import axios from 'axios';
import { captureAdminRadioValue, captureUserRadioValue, captureSuperRadioValue, handleUserName, fullName, handleToken } from 'pages/redux/actions';

import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Row, Col,} from "reactstrap";

const Login = (props) => {
    const dispatch = useDispatch();
    var click = 0;
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [loading, setloading] = React.useState('Login');
    const [disabling, setdisabling] = React.useState(false);
    
    const history = useHistory();
    const location = useLocation();

    if (location) {
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    setSendingdata(location.state.message);
                    settt(location.state.type);
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }
    }
    const [showpass, setShowPass] = React.useState(false);
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleChange = (event) => {
        // console.log(event.target.value)
        setUsername(event.target.value)
    };

    const handleClickShowPassword = () => {
        if (showpass === false) {
            setShowPass(true);
        }
        else {
            setShowPass(false)
        }
    };
    const handleChange2 = (event) => {
        // console.log(event.target.value)
        setPassword(event.target.value)
    };

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            loginPageHandler();
        }
    };

    const handleClicking = e => {
        //it triggers by pressing the enter key
        click += 1
        // console.log(location)
        // alert(location.hostname)
        if (click === 5){
            alert('Everything Alright Sir?')
        }
        if (click === 10) {
            alert('Sir?\n I sure hope and wish you are alright')
        }
        if (click === 15) {
            alert('I will provide you some Contacts which will help you to get through your Depression, OCDS or whatever you are going through')
        }
        if (click === 20) {
            alert('9152987821 can help you with your depression and Suicidal Thoughts or you can browse some more')
        }
        if (click === 30) {
            alert('We are sorry that you are going through this, you will be now to a Psychological Help center')
            window.open('https://yourdost.com/')
        }
    };

    const loginPageHandler = () => {
        // console.log("login clicked");
        // console.log('entered');
        setloading(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
        setdisabling(true)
        if ((username.length < 1) || (password.length < 1)) {
            setSendingdata('Please Enter all Credentials Properly')
            settt('error')
            setOpen(true);
            setloading('Login')
            setdisabling(false)
            return 0;
        }
        var inp = { 'username': username, 'password': password }
        // console.log(inp)
        axios.post(process.env.REACT_APP_DOMAIN+'/login', inp)
            .then((response) => {
                // console.log(response.data)
                if (response.data.status === 201) {
                    if (response.data.sadmin === true) {
                        // console.log('super');
                        dispatch(handleToken(response.data.header))
                        dispatch(handleUserName(response.data.username));
                        dispatch(fullName(response.data.first_name+' '+response.data.last_name));
                        dispatch(captureSuperRadioValue(true))
                        // console.log(response.data.header)
                        setloading('Login')
                        setdisabling(false)
                        history.push("/main/home");
                    }
                    else {
                        if (response.data.admin === true) {
                            // console.log('admin');
                            dispatch(handleToken(response.data.header))
                            // console.log(response.data.username)
                            dispatch(handleUserName(response.data.username));
                            dispatch(fullName(response.data.first_name + ' ' + response.data.last_name));
                            dispatch(captureAdminRadioValue(true))
                            // console.log(response.data.header)

                            setloading('Login')
                            setdisabling(false)
                            // history.push("/super-admin/home");
                            history.push("/main/home");
                        }
                        else {
                            // console.log('User account');
                            dispatch(handleToken(response.data.header))
                            dispatch(handleUserName(response.data.username));
                            dispatch(fullName(response.data.first_name + ' ' + response.data.last_name));
                            dispatch(captureUserRadioValue(true))
                            // console.log(response.data.header)
                            // console.log('user')
                            setloading('Login')
                            setdisabling(false)
                            history.push("/main/home");
                        }
                    }
                } else {
                    setSendingdata(response.data.message)
                    settt('error')
                    setOpen(true);
                    setloading('Login')
                    setdisabling(false)
                }
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went wrong, Please Try Againc')
                settt('error')
                setOpen(true);
                setloading('Login')
                setdisabling(false)
            })
    };
    return (
        <>
            <Col lg="5" md="7">
                <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-5">
                        <div className="btn-wrapper text-center">
                            <Button
                                className="btn-neutral btn-icon"
                                color="default"
                                onClick={handleClicking}
                            >
                                <span className="btn-inner--icon">
                                    <img
                                        alt="..."
                                        src={
                                            require("../../assets/img/kj.png")
                                                .default
                                        }
                                    />
                                </span>
                                <span className="btn-inner--text">Login Page</span>
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                        <Form role="form">
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative" style={{ padding: '2px 0px',backgroundColor: 'white' }}>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-circle-08" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        autoFocus
                                        placeholder="Username"
                                        type="text"
                                        onChange={handleChange}
                                    />
                                </InputGroup>
                            </FormGroup>
                            <FormGroup>
                                <InputGroup className="input-group-alternative" style={{ backgroundColor: 'white' }}>
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-lock-circle-open" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        placeholder="Password"
                                        type={showpass ? "text" : "password"}
                                        onChange={handleChange2}
                                        onKeyDown={handleKeypress}
                                        style={{ marginTop: '2px' }}
                                    />
                                    <InputGroupAddon addonType="append" style={{ backgroundColor: 'white' }}>
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            style={{ color: '#acb5bc', backgroundColor: 'transparent', padding: '0px 10px' }}
                                            disableRipple
                                        >
                                            {showpass ? <Visibility style={{ width: 18 }}/> : <VisibilityOff style={{ width: 18 }}/>}
                                        </IconButton>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                            <div className="custom-control custom-control-alternative custom-checkbox">
                            </div>
                            <div className="text-center">
                                <Button className="my-0" color="primary" type="button"
                                    onClick={loginPageHandler} disabled={disabling} >
                                    {loading}
                                </Button>
                            </div>
                        </Form>
                        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                            <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                        </Snackbar>
                    </CardBody>
                </Card>
                <Row className="mt-3">
                    <Col xs="6">
                        <a
                            className="text-light"
                            href="forgot-password"
                        >
                            <small>Forgot password?</small>
                        </a>
                    </Col>
                    <Col className="text-right" xs="6">
                        <a
                            className="text-light"
                            href="signup"
                        >
                            <small>Create new account</small>
                        </a>
                    </Col>
                </Row>
            </Col>
        </>
    );
};

// export default Login;

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
    }
}

export default connect(mapStateToProps)(Login);